import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ImageCropperExtraComponent } from './image-cropper-extra.component';
import { ImageCropperExtraService } from './image-cropper-extra.service';

@NgModule({
  imports: [
    TranslateModule,
    CommonModule
  ],
  exports: [ImageCropperExtraComponent],
  declarations: [ImageCropperExtraComponent],
  providers: [ImageCropperExtraService]
})
export class ImageCropperExtraModule {
  static forRoot(): ModuleWithProviders<ImageCropperExtraModule> {
    return {
      ngModule: ImageCropperExtraModule,
      providers: [
        ImageCropperExtraService
      ]
    };
  }
}
